import type { SceneContent } from '../../presentation/types';

export const closing: SceneContent = {
  id: 'closing',
  shortLabel: 'CLOSE',
  title: 'Closing',
  seconds: 35,
  brand: 'moderta',
  cinematic: true,
  bridgeIn: 'Let us finish where we started.',
  atmosphere: (step) =>
    step <= 1 ? { pattern: 'inward', density: 0.2, opacity: 0.06, cameraZ: 14 }
    : step >= 3 ? { pattern: 'orbit', density: 0.18, opacity: 0.07, cameraZ: 14 }
    : { pattern: 'ambient', density: 0.08, opacity: 0.03, cameraZ: 13.5 },
  script: {
    title: 'Closing',
    onScreen: ['MODERTA', 'Ideas → Systems → Impact'],
    visual: 'The product names fade until only their connecting lines remain. The lines swing together and converge into the Moderta mark, a hexagon with one point of light at its centre. MODERTA resolves beneath it, then Ideas → Systems → Impact, with the opening network halo returning. The frame holds.',
    narration: [
      'Every product you have seen today is a line back to the same place.',
      'Different problems, one way of building.',
      'Moderta.',
      'Ideas, systems, impact. Thank you.',
    ],
    presenterNotes: [
      'Products fade; only their lines remain. Stay quiet.',
      'Lines converge into the mark. Still quiet.',
      '"Moderta."',
      'End card. Hold for several seconds; take questions from here.',
    ],
  },
};
